import { StyleSheet, Dimensions } from 'react-native';

const screenHeight = Dimensions.get('screen').height;

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    marginBottom: 15,
    maxHeight: screenHeight - screenHeight * 0.3,
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginLeft: 15,
    marginRight: 15,
    marginTop: 20,
    marginBottom: 15,
  },
  headerTextTitle: {
    fontSize: 14,
    color: '#89909B',
    letterSpacing: 1.25,
    alignItems: 'center',
    textAlign: 'center',
    paddingTop: 5,
  },
  descriptionTextTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginLeft: 15,
    marginRight: 15,
    marginTop: 20,
  },
  descriptionTextTitle: {
    fontSize: 13,
    letterSpacing: 1.25,
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginLeft: 15,
    marginRight: 15,
    marginTop: 20,
    borderBottomColor: '#89909B',
  },
  descriptionContainerBorder: {
    paddingBottom: 10,
    borderBottomWidth: 0.3,
  },
  description: {
    fontSize: 13,
    letterSpacing: 1.25,
  },
  headerCloseButton: {
    position: 'absolute',
    top: 3,
    right: 10,
    zIndex: 9000,
    alignItems: 'center',
    justifyContent: 'center',
    width: 25,
    height: 25,
    borderRadius: 4,
  },
  touchableHitSlop: {
    top: 15,
    right: 15,
    bottom: 15,
    left: 15,
  },
});
